import { format } from "date-fns";

export const computeHeadline = ({
  mobileSummary, metaSummary, socialMirrorSummary, facebookCampaign, ctvPublishers = [],
  googleAdsData, tiktokImpressions = 0, tiktokClicks = 0, pmaxImpressions = 0, pmaxClicks = 0,
  appfrontData, brandChannelImpressions = 0, trafficData,
}) => {
  const fbImp = facebookCampaign?.has_data ? facebookCampaign?.overview?.impressions || 0 : metaSummary?.overview?.total_impressions || 0;
  const fbClicks = facebookCampaign?.has_data ? facebookCampaign?.overview?.clicks || 0 : metaSummary?.overview?.total_clicks || 0;
  const impressions =
    (mobileSummary?.overview?.total_impressions || 0) + fbImp +
    (socialMirrorSummary?.overview?.total_impressions || 0) +
    ctvPublishers.reduce((s, p) => s + (p.impressions || 0), 0) + brandChannelImpressions +
    (googleAdsData?.summary?.total_impressions || 0) + tiktokImpressions +
    (appfrontData?.summary?.total_impressions || 0) + pmaxImpressions;
  const clicks =
    (mobileSummary?.overview?.total_clicks || 0) + fbClicks +
    (socialMirrorSummary?.overview?.total_clicks || 0) +
    (googleAdsData?.summary?.total_clicks || 0) + tiktokClicks + pmaxClicks;
  return { impressions, clicks, visits: trafficData?.totals?.total_sessions || 0 };
};

export const brandChannelsInRange = (channels = [], start, end) =>
  channels.reduce((sum, ch) => {
    const imp = parseInt(ch.impressions) || 0;
    if (!imp) return sum;
    if (!start || !end || !ch.report_start || !ch.report_end) return sum + imp;
    return ch.report_start <= end && ch.report_end >= start ? sum + imp : sum;
  }, 0);

const iso = (d) => format(d, "yyyy-MM-dd");
const parse = (s) => new Date(s + "T00:00:00");

export const previousRange = (start, end) => {
  if (!start || !end) return null;
  const s = parse(start);
  const e = parse(end);
  const monthAligned = s.getDate() === 1 && new Date(e.getFullYear(), e.getMonth() + 1, 0).getDate() === e.getDate();
  if (monthAligned) {
    const months = (e.getFullYear() - s.getFullYear()) * 12 + e.getMonth() - s.getMonth() + 1;
    return {
      start: iso(new Date(s.getFullYear(), s.getMonth() - months, 1)),
      end: iso(new Date(s.getFullYear(), s.getMonth(), 0)),
    };
  }
  const days = Math.round((e - s) / 86400000) + 1;
  const pe = new Date(s.getFullYear(), s.getMonth(), s.getDate() - 1);
  return { start: iso(new Date(pe.getFullYear(), pe.getMonth(), pe.getDate() - days + 1)), end: iso(pe) };
};

export const pctChange = (cur, prev) => (cur > 0 && prev > 0 ? ((cur - prev) / prev) * 100 : null);

export const rangeLabel = (r) => (r ? friendlyRange(r.start, r.end) : "");

// "March 2026", "January to March 2026", "March 3 to 17, 2026" (short: "Jan to Mar 2026")
export const friendlyRange = (start, end, short = false) => {
  if (!start || !end) return "";
  const M = short ? "MMM" : "MMMM";
  const s = parse(start);
  const e = parse(end);
  const sameYear = s.getFullYear() === e.getFullYear();
  const fullMonths = s.getDate() === 1 && new Date(e.getFullYear(), e.getMonth() + 1, 0).getDate() === e.getDate();
  if (fullMonths) {
    if (sameYear && s.getMonth() === e.getMonth()) return format(s, `${M} yyyy`);
    return sameYear ? `${format(s, M)} to ${format(e, `${M} yyyy`)}` : `${format(s, `${M} yyyy`)} to ${format(e, `${M} yyyy`)}`;
  }
  if (sameYear && s.getMonth() === e.getMonth()) return `${format(s, `${M} d`)} to ${format(e, "d, yyyy")}`;
  return sameYear ? `${format(s, `${M} d`)} to ${format(e, `${M} d, yyyy`)}` : `${format(s, `${M} d, yyyy`)} to ${format(e, `${M} d, yyyy`)}`;
};
